<template>
    <customHeader title="FAQ" path="settings" />
    <q-page-container style="height: 100vh; background-color: #fafafa">
        <q-scroll-area visible style="height: 100%; width: 100%">
            <div style="padding: 3.2vw 4.2vw">
                <!-- <div class="h2 bold mg_bottom_48">FAQ</div> -->
                <div class="flex justify-between align-center" style="margin-bottom: 2.8vw">
                    <div class="b1 medium line_height_45">총 {{ data.length }}건</div>
                    <div>
                        <!-- <q-select outlined v-model="categoryCode" dense :options="categoryOptions"
              style="width: 18.33vmin; font-size: 2vmin; color: #8e8e8e" dropdown-icon="expand_less" /> -->
                        <div class="select__wrap">
                            <CusSelect :li-list="categoryOptions" v-model:current="categoryModel" @onReturn="onSelected" />

                            <!-- <q-select outlined v-model="categoryCode" :options="categoryOptions" popup-content-class="b3" class="select" option-value="value" option-label="label" option-disable="inactive" dropdown-icon="expand_less" /> -->
                        </div>
                    </div>
                </div>
                <div v-if="!isLoading" class="faq__panel">
                    <template v-if="data.length > 0" v-for="(item, index) in data" :key="item.seq">
                        <q-separator v-if="index !== 0" />
                        <Accordion :title="item.title" :category="category[item?.faqCategoryCode]" :contents="item.contents" :isLast="index === data.length - 1" />
                    </template>
                    <!-- <q-card v-if="data.length === 0" flat bordered style="border:none;font-size: 2.16vmin;">
            <q-card-actions style="justify-content: center;">
              등록된 FAQ가 없습니다.
            </q-card-actions>
          </q-card> -->
                </div>
            </div>
        </q-scroll-area>
    </q-page-container>
    <LoadingCard :is-show="isLoading" />
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { getFaq } from '@/api/modules/study';
import customHeader from '@/components/layouts/header/header.vue';
import Accordion from './accordion.vue';
import LoadingCard from '@/components/quasar/loadingCard.vue';
import CusSelect from '@/components/widget/CusSelect.vue';
import { useRoute } from 'vue-router';
import { monitoringLog } from '@/api/modules/monitoring';

const route = useRoute();
const channelCode = ref(null);
const categoryCode = ref('전체');
const data = ref([]);
const isLoading = ref(false);
const categoryOptions = [
    { label: '전체', value: '전체' },
    { label: '회원', value: 1 },
    { label: '결제', value: 2 },
    { label: '학습서비스', value: 3 },
    { label: 'LMS 이용', value: 4 },
    { label: 'APP 이용', value: 5 },
    { label: '기타', value: 6 },
];

const category = {
    전체: '전체',
    1: '회원',
    2: '결제',
    3: '학습서비스',
    4: 'LMS 이용',
    5: 'APP 이용',
    6: '기타',
};
const getData = () => {
    isLoading.value = true;
    getFaq(
        {
            categoryCode: categoryCode.value.value !== '전체' ? categoryCode.value.value : null,
        },
        (rs) => {
            // console.log(rs);
            data.value = rs;
            // console.log('--getData getData-rs-', rs);
            isLoading.value = false;
        },
    );
};

watch(
    () => categoryCode.value,
    (newValue) => {
        getData();
    },
);

onMounted(() => {
    getData();

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('faq monitoringLog API response ===', res);
    });
});

const categoryModel = ref({ label: '전체', value: '전체' });

const onSelected = (index) => {
    // console.log('- - onSelected- -', index);
    categoryCode.value = categoryOptions[index];
};
</script>

<style scoped lang="scss">
.title {
    color: #222222;
}
::v-deep {
    input {
        //padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            overflow: hidden;
            margin-top: 0px;

            &__control {
                align-items: center;
                height: 100%;
                border-radius: 1vmin;
                width: 11vw;
                //height: 3.2vw;
                min-height: 40px;
                padding: 0.92vmin 1.83vmin;
                text-align: center;
            }

            &__native {
                min-height: inherit !important;
                padding: 0;
                font-size: 1.2vw;
                line-height: 1.6vw;
                color: $color_gray_600;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                // padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }
    }

    .q-field__control-container {
        align-items: center;
        padding: 0 2.83vmin;
    }

    .q-field__marginal {
        width: 2.1vw;
        height: 2.1vw;
        min-height: inherit !important;
        padding-left: 0;
    }
    .q-select__dropdown-icon {
        width: 2.1vw;
        height: 2.1vw;
        text-indent: 9999rem;
        background: url('@/assets/images/icon/ico_down.svg') no-repeat center right/ contain;
    }
    .q-field__append {
        .q-icon {
            color: $color_gray_600;
            font-size: 2.5vw;
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.select__wrap {
    display: flex;
    .select {
        // width: 18.33vmin;
        font-size: 1.2vw;
        line-height: 1.6vw;
        color: $color_gray_600;
    }
}
.align-center {
    align-items: center;
}
.faq__panel {
    padding: 0 3.4vw;
    border: 1px solid $color_gray_400;
    @include border-radius(0.8vw);
    background: $color_white;
}
</style>
